module.exports = __webpack_public_path__ + "img/logo.c7db0f8a.png";